import { GEO_SEARCH_LIMIT, GEO_TARGET_TYPE } from 'apps/ads/models/AdSet/constants'
import * as dataSelectors from 'apps/ads/selectors/dataSelectors'
import { AdsApi } from 'shared/api/requests/ads'
import { GetTargetingSearchResponse, SearchTargetResponse } from 'shared/api/requests/ads/schema'
import { createAsyncAction } from 'shared/lib/redux'

const NAMESPACE = 'adsTargeting'

const errorMarkupOptions = { scope: 'fb_ads', section: 'ad_constructor' } as const

const LOCATIONS_MAP_DEFAULTS: Record<string, unknown[]> = {
  countries: [],
  regions: [],
  cities: [],
  zips: [],
  places: [],
  custom_locations: [],
  geo_markets: [],
  electoral_districts: [],
  country_groups: [],
}

interface DetailedTargetingArg {
  adSetId: string | number
  query?: string
}

export const searchLocations = createAsyncAction<SearchTargetResponse, string | undefined>(
  `${NAMESPACE}/searchLocations`,
  async (query = '') => {
    const { data } = await AdsApi.searchTarget({
      query: { type: GEO_TARGET_TYPE, q: query, params: { limit: GEO_SEARCH_LIMIT } },
    })
    return data
  },
  { errorMarkupOptions, onError: () => true },
)

export const fetchLocationsMeta = createAsyncAction<
  SearchTargetResponse,
  Record<string, unknown[]>
>(
  `${NAMESPACE}/fetchLocationsMeta`,
  async (locationsMap) => {
    const merged = { ...LOCATIONS_MAP_DEFAULTS, ...locationsMap }
    const params: Record<string, string> = {}
    for (const key of Object.keys(LOCATIONS_MAP_DEFAULTS)) {
      params[key] = JSON.stringify(merged[key])
    }

    const { data } = await AdsApi.searchTarget({
      query: { type: 'adgeolocationmeta', params },
    })
    return data
  },
  { errorMarkupOptions },
)

export const fetchLocales = createAsyncAction<SearchTargetResponse, void>(
  `${NAMESPACE}/fetchLocales`,
  async () => {
    const { data } = await AdsApi.searchTarget({
      query: { type: 'adlocale', q: '', params: { limit: 1000 } },
    })
    return data
  },
  { errorMarkupOptions },
)

export const searchDetailedTargeting = createAsyncAction<
  GetTargetingSearchResponse,
  DetailedTargetingArg
>(
  `${NAMESPACE}/searchDetailedTargeting`,
  async ({ adSetId, query = '' }, { getState }) => {
    const adSet = dataSelectors.getAdSetById(getState(), adSetId)
    const { data } = await AdsApi.getTargetingSearch({
      query: { ad_account_id: String(adSet.accountId), q: query },
    })
    return data
  },
  { errorMarkupOptions },
)
